import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F8865SchdKService {

  constructor(private http: HttpClient) { }

  load8865SchdKWPDForEntity(
    baseUrl: string,
    loadParams: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // 🔴 CRITICAL: Use query parameters like AngularJS JsonObjectFactory.getJSONObj
    const url = `${baseUrl}/loadJsonObject`;
    
    // Build query parameters like AngularJS
    let queryParams = new URLSearchParams();
    
    // Add specific load parameters first (action_code, etc.)
    Object.keys(loadParams).forEach(key => {
      if (loadParams[key] !== undefined && loadParams[key] !== null) {
        queryParams.set(key, loadParams[key].toString());
      }
    });
    
    // Add global service parameters  
    if (globalService) {
      Object.keys(globalService).forEach(key => {
        if (globalService[key] !== undefined && globalService[key] !== null) {
          queryParams.set(key, globalService[key].toString());
        }
      });
    }
    
    // Add filter parameters
    if (filterParams) {
      Object.keys(filterParams).forEach(key => {
        if (filterParams[key] !== undefined && filterParams[key] !== null) {
          queryParams.set(key, filterParams[key].toString());
        }
      });
    }
    
    const finalUrl = `${url}?${queryParams.toString()}`;
    console.log('F8865SchdK load URL:', finalUrl);
    
    // Use GET request like JsonObjectFactory might be doing
    return this.http.get<any>(finalUrl, { withCredentials: true });
  }

  save8865SchdKWPDForEntity(
    baseUrl: string,
    clob_settings: any,
    clob_data: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    const url = `${baseUrl}/saveJsonObject?action_code=4d65p3`;
    
    // Build payload EXACTLY like original AngularJS with proper fallbacks
    let params = _.merge({}, globalService || {}, filterParams);
    
    // Essential parameters with fallbacks (EXACTLY like working AngularJS)
    params.clob_settings = JSON.stringify(clob_settings);
    params.clob_data = JSON.stringify(clob_data);
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || globalService?.jcd_key || "250";
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || "RAF";
    params.is_issue_key_enabled = "N";
    params.process_name = "Save F8865 Schd-K WPD for Entity";
    params.sso_id = clob_settings.sso_id;
    
    // Add checkLockedbj from rowData (like working AngularJS)
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "cdr_number": rowData.CDR_NO,
      "reporting_period": rowData.REPORTING_PERIOD || 1,
      "combination_key": rowData.COMBINATION_KEY,
      "scenario_key": parseInt(filterParams.scenario)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    
    console.log('Save params = ', params);
    console.log('clob_data = ', params.clob_data);
    console.log('clob_settings = ', params.clob_settings);

    // 🔴 CRITICAL: Use application/x-www-form-urlencoded (form data) like working AngularJS
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
